// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"240":"workshop-edit-job","482":"group-job","494":"workshop-edit-jon","984":"workshop"}[chunkId] || chunkId) + "-legacy." + {"216":"3968206b","240":"fa31602f","249":"4c489d6d","482":"d870cf24","494":"2102d485","824":"66832b42","875":"b46fa1f5","984":"09741860"}[chunkId] + ".js";
};